// react-bootstrap imports
import { useEffect, useState } from "react"

// components imports
import { userLogado } from "services/LoginFunctions"
import { PegarTodasMultas } from "services/CallAPIs"
//import { TabelaDocs, PaginationBar } from "components/TabelaDocumentos"
import * as Links from "constants/links"
import { useNavigate } from "react-router-dom"


export function MeusDocumentosScreen()
{
    const navigate = useNavigate()
    const [listaDocs, setListaDocs] = useState([])
    // const [mostrarTodosProcessos, setMostrarTodosProcessos] = useState(false)
    const [numPages, setNumPages] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 10
    // const [itemsPerPage, setItemsPerPage] = useState(10)
    // const [numDocs, setNumDocs] = useState(0)

    useEffect(() => {
        async function fetchData()
        {
            const allDocs = await PegarTodasMultas() // PegarTodosDocumentosBD()
            if (allDocs === undefined)
            {
                setListaDocs([])
                return
            }

            setNumPages(Math.ceil(allDocs.length / itemsPerPage))
            setListaDocs(allDocs)
            // try
            // {
                
            // }
            // catch(error)
            // {
            //     // alert("Não consegui pegar os documentos no banco de dados. \n Motivo do erro: " + error)
            // }
        }

        fetchData()
      }, [])

    if (!userLogado)
    {
        navigate(Links.SEM_PERMISSAO)
    }

    // const onChangeItemsPerPage = () => { setItemsPerPage(Number(getRadioValue("itemsPerPageRange"))) }
    // const onChangeVerTodosProcessos = () => { setMostrarTodosProcessos(!mostrarTodosProcessos) }
    // const RedirectToEstatisticas = () => { navigate("/MinhaConta", {state:{tabID: 3, processos: listaProcessos}}) }

    // console.log("funcionarioID")
    // console.log(funcionarioID)

    /* <div className = "d-flex">
            <p className = "fw-bold align-self-center">Filtros</p>
            <Switch Name={"switchTodosProcessos"} Label={"Ver todos"} OnChange={onChangeVerTodosProcessos} />
        </div>

        <div className = "d-flex align-items-center justify-content-center">
            <div>                
                <Radio Name="itemsPerPageRange" Label="N° protocolos por página" Options={[1, 10, 100, 1000]} OnChange={onChangeItemsPerPage} />
            </div>
            <div className = "d-flex justify-content-around">
                <Button className="btn btn-primary" onClick={RedirectToEstatisticas}>Estatísticas</Button> 
            </div>
        </div> */

    // const items = []
    // for (let i = 0 ; i <= numberOfPages - 1 ; i += 1)
    // {
    //     items.push(<Pagination.Item active={i === currentPage} onClick={() => {setCurrentPage(i)}} key={i + 1}>{i + 1}</Pagination.Item>)
    // }

    // return <><p className = "fw-bold mt-3 align-self-center">Esta página está em construção. Em breve você verá seus processos aqui.</p></>
    return(<></>)
    /*return (
        
        <div className="container col-md-auto bg-white border border-dark rounded-5 mb-3 shadow">
            <div className = "d-flex flex-column">
                {
                    !listaDocs || listaDocs.length <= 0 ?
                        <p className = "fw-bold mt-3 align-self-center">Não há documentos salvos</p>
                    :
                    <>
                        <p className = "fw-bold mt-3 align-self-center">Todos os documentos</p>
                        <TabelaDocs listaDocs={listaDocs} page={currentPage} mostrarTodos={true} />
                        <div className="align-self-center">
                            <PaginationBar currentPage={currentPage} numPages={numPages} setPage={setCurrentPage}/>
                        </div>
                    </>
                }
            </div>
        </div>
    )*/
}